import Vue from 'vue';
import Router from 'vue-router';

// 工作台
import WORKBENCH from '../views/workbench/route';
// 用户管理
import UserManagement from '../views/userManagement/route';
// app 推广管理
import AppPromotionConfiguration from '../views/appPromotionConfiguration/route';
// 文章文章管理
import ArticleInformationManagement from '../views/articleInformationManagement/route';
// 基础管理
import BasicManagement from '../views/basicManagement/route';
// 数字课程管理
import DigitalCourseManagement from '../views/digitalCourseManagement/route';
// 数字课程管理
import examManagement from '../views/examManagement/route';
// 资源管理
import ResourceManagement from '../views/resourceManagement/route';
// 系统管理
import SystemManagement from '../views/systemManagement/route';
// 教学管理
import teachManagement from '../views/teachManagement/route';
// 试卷管理
import paperManagement from '../views/paperManagement/route';
// 试题管理
import questionManagement from '../views/questionManagement/route';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/Login',
      component: () =>
        import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
      meta: {
        title: '登录',
      },
      children: [
        ...WORKBENCH,
        ...UserManagement,
        ...AppPromotionConfiguration,
        ...ArticleInformationManagement,
        ...BasicManagement,
        ...DigitalCourseManagement,
        ...ResourceManagement,
        ...SystemManagement,
        ...teachManagement,
        ...paperManagement,
        ...examManagement,
        ...questionManagement,
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
      meta: {
        title: '登录',
      },
    },
  ],
});
